export const borderStyleProps = {
  borderWidth: true,
  borderBlockWidth: true,
  borderBlockStartWidth: true,
  borderBlockEndWidth: true,
  borderInlineWidth: true,
  borderInlineStartWidth: true,
  borderInlineEndWidth: true,
  borderColor: true,
  borderBlockColor: true,
  borderBlockStartColor: true,
  borderBlockEndColor: true,
  borderInlineColor: true,
  borderInlineStartColor: true,
  borderInlineEndColor: true,
  borderStyle: true,
  borderBlockStyle: true,
  borderBlockStartStyle: true,
  borderBlockEndStyle: true,
  borderInlineStyle: true,
  borderInlineStartStyle: true,
  borderInlineEndStyle: true,
  borderRadius: true,
  borderStartStartRadius: true,
  borderStartEndRadius: true,
  borderEndStartRadius: true,
  borderEndEndRadius: true
};
export const layoutStyleProps = {
  display: true,
  float: true,
  overflow: true,
  overflowX: true,
  overflowY: true,
  flexDirection: true,
  justifyContent: true,
  alignItems: true,
  flexWrap: true,
  alignSelf: true,
  justifySelf: true,
  flex: true,
  flexBasis: true,
  flexGrow: true,
  flexShrink: true,
  order: true,
  gap: true,
  rowGap: true,
  columnGap: true,
  visibility: true,
  clipPath: true
};
export const flexItemLayoutStyleProps = {
  alignSelf: true,
  justifySelf: true,
  flex: true,
  flexBasis: true,
  flexGrow: true,
  flexShrink: true,
  order: true
};
export const gridContainerLayoutStyleProps = {
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridTemplate: true,
  columnGap: true,
  rowGap: true,
  gridColumnGap: true,
  gridRowGap: true,
  justifyItems: true,
  alignItems: true,
  justifyContent: true,
  alignContent: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridAutoFlow: true,
  grid: true
};
export const gridItemLayoutStyleProps = {
  gridColumnStart: true,
  gridColumnEnd: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridColumn: true,
  gridRow: true,
  gridArea: true,
  justifySelf: true,
  alignSelf: true
};
export const positionStyleProps = {
  position: true,
  inset: true,
  insetBlockStart: true,
  insetBlockEnd: true,
  insetInlineStart: true,
  insetInlineEnd: true,
  zIndex: true
};
export const sizeStyleProps = {
  blockSize: true,
  minBlockSize: true,
  maxBlockSize: true,
  inlineSize: true,
  minInlineSize: true,
  maxInlineSize: true
};
export const spaceStyleProps = {
  padding: true,
  paddingInline: true,
  paddingInlineStart: true,
  paddingInlineEnd: true,
  paddingBlock: true,
  paddingBlockStart: true,
  paddingBlockEnd: true,
  margin: true,
  marginInline: true,
  marginInlineStart: true,
  marginInlineEnd: true,
  marginBlock: true,
  marginBlockStart: true,
  marginBlockEnd: true
};
export const tableStyleProps = {
  borderCollapse: true,
  borderSpacing: true,
  captionSide: true,
  emptyCells: true,
  tableLayout: true
};
export const textStyleProps = {
  color: true,
  fontStyle: true,
  textAlign: true,
  textTransform: true,
  textDecoration: true,
  wordBreak: true,
  typography: true,
  overflowWrap: true
};
export const transitionStyleProps = {
  transition: true,
  transitionProperty: true,
  transitionDuration: true,
  transitionTimingFunction: true,
  transitionDelay: true
};
export const backgroundStyleProps = {
  backgroundColor: true
};
export const boxShadowStyleProps = {
  boxShadow: true
};
export const listStyleProps = {
  listStyleType: true,
  listStylePosition: true
};
export const mediaStyleProps = {
  objectFit: true
};
export const cursorStyleProps = {
  cursor: true
};
export const pointerEventsStyleProps = {
  pointerEvents: true
};

/**
 * This object is a collection of all style prop keys that can be passed to
 * components. It is used to efficiently check if a prop passed to a
 * component is a style prop allowed by the design system.
 *
 * A Set data structure is not used because TypeScript doesn't directly
 * enforce the completeness of a Set based on an interface's keys.
 * In practice, this means that if a property is modified in any of the
 * interfaces that make up the `StyleProps` union, TypeScript would not
 * show an error in the Set definition. For that reason, we use an object
 * instead, where the value of each key doesn't matter, only the presence
 * of the key itself.
 */
export const stylePropKeys = Object.assign({}, borderStyleProps, layoutStyleProps, positionStyleProps, sizeStyleProps, spaceStyleProps, tableStyleProps, textStyleProps, backgroundStyleProps, boxShadowStyleProps, listStyleProps, mediaStyleProps, cursorStyleProps, gridContainerLayoutStyleProps, gridItemLayoutStyleProps, pointerEventsStyleProps, transitionStyleProps);